import actions from './actions';
import types from './types';

const analyticsApiKeysModule = {
  state: () => ({
    apiKeys: [],
    apiKeysLoading: false,
    creatingApiKey: false,
    extendingApiKey: false,
    revokingApiKey: false,
    newApiKey: null,
    error: null,
  }),
  mutations: {
    [types.GET_API_KEYS_START]: (state) => {
      state.apiKeysLoading = true;
    },
    [types.GET_API_KEYS_SUCCESS]: (state, data) => {
      state.apiKeys = data || [];
      state.apiKeysLoading = false;
    },
    [types.GET_API_KEYS_FAILURE]: (state, error) => {
      state.apiKeysLoading = false;
      state.error = error;
    },

    [types.CREATE_API_KEY_START]: (state) => {
      state.creatingApiKey = true;
      state.newApiKey = null;
    },
    [types.CREATE_API_KEY_SUCCESS]: (state, data) => {
      state.creatingApiKey = false;
      state.newApiKey = data;
    },
    [types.CREATE_API_KEY_FAILURE]: (state, error) => {
      state.creatingApiKey = false;
      state.error = error;
    },

    [types.EXTEND_API_KEY_START]: (state) => {
      state.extendingApiKey = true;
    },
    [types.EXTEND_API_KEY_SUCCESS]: (state) => {
      state.extendingApiKey = false;
    },
    [types.EXTEND_API_KEY_FAILURE]: (state, error) => {
      state.extendingApiKey = false;
      state.error = error;
    },

    [types.REVOKE_API_KEY_START]: (state) => {
      state.revokingApiKey = true;
    },
    [types.REVOKE_API_KEY_SUCCESS]: (state) => {
      state.revokingApiKey = false;
    },
    [types.REVOKE_API_KEY_FAILURE]: (state, error) => {
      state.revokingApiKey = false;
      state.error = error;
    },
  },
  actions,
  namespaced: true,
};

export default analyticsApiKeysModule;
